module.exports = __webpack_public_path__ + "img/096-mozambique.f6d717c4.svg";